// #ux-redesign-start: InboxViewListItem — copia 1:1 del de Doctors. Mantiene
// la distinción unread / readed (border-left brand) y el preview con stripHtml.
// Sin D&D ni drag handle (Patients no tiene folders custom).
// Mobile grid 2x2: [chk priority name fecha] / [subject preview]
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslate } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import { ListGroupItem } from 'reactstrap';
import BtnPriority from '../Actions/BtnPriority';

import {
  actionGetMessage,
  actionGetOutboxMessage,
  actionSetSelectedMessages,
} from 'store/actions/messagesActions';
import Dates from 'helpers/Dates';
import { stripHtml } from 'helpers/sanitizeMessage';

const InboxViewListItem = (props) => {
  const { item } = props;
  const ta = useTranslate('a11y');
  const dispatch = useDispatch();
  const { selectedMessages, box } = useSelector(
    (state) => state.messagesReducer
  );

  const recipientsTotal = item.to.length;
  const key = item._id;

  const showMessage = (id) => {
    if (box === 'outbox') {
      dispatch(actionGetOutboxMessage(id));
    } else {
      dispatch(actionGetMessage(id));
    }
  };

  const handleCheckbox = (event, message_id) => {
    let newSelectedMessages;
    if (event.target.checked) {
      newSelectedMessages = [...selectedMessages, message_id];
    } else {
      newSelectedMessages = selectedMessages.filter((id) => id !== message_id);
    }
    dispatch(actionSetSelectedMessages(newSelectedMessages));
  };

  const diff = Dates.dateDiff(item.date, moment());
  const dateCondition = diff.years === 0 && diff.months === 0 && diff.days <= 2;

  const [attachments, setAttachments] = useState(false);
  useEffect(() => {
    if (item.files && item.files.length !== 0) setAttachments(true);
  }, [item]);

  return (
    <ListGroupItem
      id={`item-${key}`}
      data-id={key}
      className={`inbox-message${
        !item.flags?.readed && box !== 'outbox' ? ' inbox-message--unread' : ''
      }`}
      onClick={(e) => {
        if (
          (e.target.closest &&
            (e.target.closest('.message-select') ||
              e.target.closest('.message-priority'))) ||
          e.target.nodeName === 'INPUT' ||
          e.target.nodeName === 'LABEL'
        ) {
          return;
        }
        showMessage(item._id, key);
      }}
    >
      <div className="d-flex">
        <span
          className="message-select"
          onClick={(e) => e.stopPropagation()}
        >
          <input
            type="checkbox"
            data-id={key}
            checked={selectedMessages.includes(item._id)}
            onChange={(e) => handleCheckbox(e, item._id)}
            onClick={(e) => e.stopPropagation()}
            aria-label={ta('select-message')}
          />
        </span>

        {box !== 'outbox' && (
          <>
            <div className="message-priority">
              <BtnPriority message={item} />
            </div>
            <div className={item.flags?.readed ? 'readed' : 'not-readed'} />
            <div className="message-name">
              {item.thread && item.thread.length && recipientsTotal > 1 ? (
                <>
                  {item.from.firstName} {item.from.lastName} ...{' '}
                  {item.to[recipientsTotal - 1].firstName}{' '}
                  {item.to[recipientsTotal - 1].lastName} ({recipientsTotal})
                </>
              ) : item.thread && item.thread.length ? (
                <>
                  {item.thread[item.thread.length - 1].from.firstName}{' '}
                  {item.thread[item.thread.length - 1].from.lastName}
                </>
              ) : (
                <>
                  {item.from.firstName} {item.from.lastName}
                </>
              )}
            </div>
          </>
        )}

        {box === 'outbox' && (
          <div className="message-name ml-2">
            {item.to[0].firstName} {item.to[0].lastName}
          </div>
        )}

        <div className="message-subject">
          {item.subject} -{' '}
          <div className="message-inner-subject">
            {stripHtml(
              item.thread && item.thread.length
                ? item.thread[item.thread.length - 1].body
                : item.body
            )}
          </div>
        </div>

        {item.thread && item.thread.length > 0 && (
          <div className="inbox-thread-counter">{item.thread.length}</div>
        )}

        {attachments && <div className="ml-auto mr-2 icon-attach1" />}

        {dateCondition && (
          <div className="message-date ml-auto">
            {moment(item.date).fromNow()}
          </div>
        )}
        {!dateCondition && (
          <div className="message-date ml-auto">
            {moment().format('D') === moment(item.date).format('D')
              ? moment(item.date).format('HH:mm')
              : moment(item.date).format('D MMM')}
          </div>
        )}
      </div>
    </ListGroupItem>
  );
};

export default InboxViewListItem;
// #ux-redesign-end
